"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTitleColor = void 0;
var getTitleColor = function (palette) { return palette.grey[100]; };
exports.getTitleColor = getTitleColor;
